<template>
  <v-row>
    <v-col cols="12">
      <e-label class="font-weight-medium">Conteúdos:</e-label>
    </v-col>
    <v-col v-for="(conteudo, index) in parsedConteudoPolivalencia" :key="index" cols="12" md="6">
      <v-card outlined class="pa-3 rounded-lg">
        <h3 class="text-primary mb-2">
          {{ getDisciplineDescription(index) }}
        </h3>
        <div v-html="formatarQuebrasDeLinha(conteudo)"></div>
      </v-card>
    </v-col>
    <v-col cols="12">
      <e-label class="font-weight-medium mb-5">Metodologia</e-label>
      <div class="font-weight-regular" v-html="formatarQuebrasDeLinha(aula.metodologia)"></div>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "ConteudoAulaPolivalente",
  props: {
    aula: {
      type: Object,
      required: true,
    },
  },
  computed: {
    parsedConteudoPolivalencia() {
      try {
        return JSON.parse(this.aula.conteudo_polivalencia || "[]");
      } catch (error) {
        this.$handleError(error);
        return [];
      }
    },
  },
  methods: {
    getDisciplineDescription(index) {
      return this.aula.disciplinas_com_descricao?.[index]?.descricao || `Disciplina ${index + 1}`;
    },
    formatarQuebrasDeLinha(texto) {
      if (!texto) return "";
      return texto.replace(/\n/g, "<br>");
    },
  },
};
</script>

<style scoped>
.saltar-linha {
  white-space: pre-line;
}
</style>
